module.exports = __webpack_public_path__ + "media/debris-3.18932ad5.webm";